/**
 * Logger utility - Chỉ log ở môi trường development
 * Tất cả log sẽ bị tắt hoàn toàn ở production để tránh rò rỉ thông tin
 */

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';

/**
 * Logger object với các method tương tự console
 * Chỉ hoạt động ở development, im lặng hoàn toàn ở production
 */
export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  group: (...args: any[]) => {
    if (isDevelopment) {
      console.group(...args);
    }
  },
  
  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
  
  table: (...args: any[]) => {
    if (isDevelopment) {
      console.table(...args);
    }
  },
};

/**
 * Disable tất cả console methods ở production
 * Đây là biện pháp bổ sung để đảm bảo không có log nào bị rò rỉ
 */
export function disableConsoleInProduction() {
  if (!isDevelopment) {
    const noop = () => {};
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.info = noop;
    console.debug = noop;
    console.group = noop;
    console.groupEnd = noop;
    console.table = noop;
  }
}
